import React from 'react';
import './view.less';

/**
 * @class CnSmartFtpGuide
 * @description 
 */
export default class CnSmartFtpGuide extends React.Component {
  static displayName = 'CnSmartFtpGuide';

  constructor(props) {
    super(props);
  }

  render() {
    return this.props.children;
  }
}
